<template>
  <v-tabs ref="topmenutabs" dense class="top-menu pa-0" align-with-title light>
    <v-tab
      v-for="(item, key) in computeMenu"
      :key="key"
      :to="{ name: item.route }"
      @click="clickTopMenu()"
    >
      <div class="top-menu-item">
        {{ item.meta.title }}
      </div>
    </v-tab>
  </v-tabs>
</template>
<script>
import userRole from '../../../mixins/userRole'
import { authRoute } from '../../../router/routeRole'

export default {
  name: 'AppTopMenu',
  components: {},
  mixins: [userRole],
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      mini: false,
      drawerWidth: 256,
      drawer: true,
      scrollSettings: {
        maxScrollbarLength: 160,
      },
    }
  },

  computed: {
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
    isPreprod() {
      return process.env.VUE_APP_PREPROD === 'true'
    },
    hideNaikinimas() {
      return false
    },
    computeMenu() {
      return this.menuList.filter(item => {
        // return item.role === '' || this.roleOr(item.role)
        return authRoute(item.route) && !item.hide
      })
    },
    menuList() {
      return [
        {
          route: 'pagrindinis',
          meta: {
            title: 'Pagrindinis',
            icon: 'mdi-view-dashboard',
          },
        },
        {
          route: 'ntSandoris',
          meta: {
            title: 'NT sandoris',
            icon: 'mdi-clock-fast',
          },
        },
        {
          route: 'hipoteka',
          meta: {
            title: 'Hipoteka / Įkeitimas',
            icon: 'mdi-book-plus-outline',
          },
        },
        {
          route: 'sutartis',
          meta: {
            title: 'Neregistruojamų daiktų sutartis',
            icon: 'mdi-clock-fast',
          },
        },
        {
          route: 'prasymasNaujas',
          meta: {
            title: 'Prašymas dėl juridinio fakto',
            icon: 'mdi-clock-fast',
          },
        },
        {
          route: 'rengiamiDokumentaiTab',
          meta: {
            title: 'Rengiami dokumentai',
            icon: 'mdi-clock-fast',
          },
        },
        {
          route: 'perduotiDokumentaiTab',
          meta: {
            title: 'Perduoti dokumentai',
            icon: 'mdi-clock-fast',
          },
        },
        {
          route: 'zurnalasGaunami',
          meta: {
            title: 'Dokumentų žurnalas',
            icon: 'mdi-clock-fast',
          },
        },
        {
          route: this.paieskaRoute,
          meta: {
            title: 'Paieška',
            icon: 'mdi-clock-fast',
          },
        },
        {
          route: 'archyvoNaikinimas',
          meta: {
            title: 'Archyvo naikinimas',
            icon: 'mdi-clock-fast',
          },
          hide: this.hideNaikinimas,
        },
        {
          route: 'administravimas',
          meta: {
            title: 'Administravimas',
            icon: 'mdi-clock-fast',
          },
        },
      ]
    },
    paieskaRoute() {
      if (this.roleOr(['P_S_pagal_JA', 'P_TZ_pagal_JA'])) {
        return 'paieskaJuridinis'
      } else if (this.roleOr(['P_S_pagal_FA', 'P_TZ_pagal_FA'])) {
        return 'paieskaFizinis'
      } else if (this.roleOr(['P_S_pagal_turta', 'P_TZ_pagal_turta'])) {
        return 'paieskaTurtas'
      } else if (this.role('P_S_pagal_koda')) {
        return 'paieskaKodas'
      } else if (this.role('KAC_darbuotojas')) {
        return 'paieskaTvirtinimas'
      }
      return 'paieskaMano'
    },
  },
  created() {
    setTimeout(() => window.dispatchEvent(new Event('resize')), 500)
  },

  methods: {
    handleDrawerCollapse() {
      this.drawerWidth = this.drawerWidth === 256 ? 64 : 256
    },
    toggleDrawer() {
      this.drawer = !this.drawer
    },
    clickTopMenu() {
      this.$store.dispatch('searchParams', null)
      this.$refs.topmenutabs.callSlider()
    },
  },
}
</script>

<style lang="scss">
.top-menu {
  background: white;
  font-family: 'Open Sans';

  .top-menu-item {
    align-self: center;
    font-size: 13px;
    font-weight: bold;
    text-transform: none;
    letter-spacing: 0rem;
    line-height: 1.5;
  }
}
</style>
